import { Journey, Segment } from "../../types";

interface FlattenedSegment extends Segment {
  journeyIndex: number;
  segmentIndex: number;
}
export default function flattenSegments(
  journeys: Journey[]
): FlattenedSegment[] {
  return journeys.flatMap((journey, journeyIndex) =>
    journey.segments.flatMap((segment, segmentIndex) => ({
      journeyIndex,
      segmentIndex,
      ...segment,
    }))
  );
}
